<template>
  <el-dialog
      :title="setId?'编辑小区':'新增小区'"
      :visible.sync="communityDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="600px"
      center>
    <el-form :model="communityForm" :rules="rules" ref="communityForm" label-width="100px">
      <el-form-item label="项目名称" >
        <el-input :value="xiangmuName" readonly></el-input>
      </el-form-item>
      <el-form-item label="小区名称" prop="name">
        <el-input v-model="communityForm.name" placeholder="请输入小区名称"></el-input>
      </el-form-item>
      <el-form-item label="小区地区" prop="region">
        <el-cascader
            style="width: 100%;"
            expand-trigger="hover"
            filterable
            placeholder="请选择小区地区"
            :options="options"
            v-model="communityForm.region"
            @change="addressChange"
        >
        </el-cascader>
      </el-form-item>
      <el-form-item label="备注" prop="beizhu">
        <el-input type="textarea" v-model="communityForm.beizhu" placeholder="请输入备注"></el-input>
      </el-form-item>
      <el-form-item class="flex align-center justify-around" label-width="0">
        <el-button class="padding-lr-xl" @click="resetForm('communityForm')">取消</el-button>
        <el-button class="padding-lr-xl" type="primary" @click="submitForm('communityForm')">提交</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import {regionData, CodeToText} from "element-china-area-data";
import {xiangMuByXiangMuJingLi,xiaoQuAdd} from "@/api/community";

export default {
  name: "communityDialog",
  props: {
    communityDialog: {
      type: Boolean,
      default: false
    },
    setId: {
      type: Number,
      default() {
        return 0;
      }
    },
    setItem: {
      type: Object
    }
  },
  data() {
    return {
      xiangmuId: '',
      xiangmuName: '',
      options: regionData,
      communityForm: {
        name: '',
        region: [],
        region_text: [],
        address: '',
        beizhu: '',
      },
      rules: {
        name: [{required: true, message: '请输入小区名称', trigger: 'blur'}],
        region: [{required: true, message: '请选择小区地区', trigger: 'change'}],
        address: [{required: true, message: '请输入详细地址', trigger: 'blur'}],
      }
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  },
  created() {
    this.xiangMuByXiangMuJingLi()
  },
  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$emit('cancelDialog', false)
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData(formName)
        }
      });
    },
    async submitData(formName) {
      let _state = await xiaoQuAdd(
          this.xiangmuId,
          this.communityForm.name,
          this.communityForm.region[0],
          this.communityForm.region_text[0],
          this.communityForm.region[1],
          this.communityForm.region_text[1],
          this.communityForm.region[2],
          this.communityForm.region_text[2],
          this.communityForm.address,
          this.communityForm.beizhu,
          this.setId ? this.setId : '',
      );
      this.$message.success(_state.info);
      this.$refs[formName].resetFields();
      this.$emit("cancelDialog", true);
    },
    //  根据地址code 换取 地址Zh
    addressChange(arr) {
      this.communityForm.region = arr;
      this.communityForm.region_text = [CodeToText[arr[0]], CodeToText[arr[1]], CodeToText[arr[2]]];
    },
    //  获取小区经理电话
    setPhone(val) {
      let _item = this.xmhlList.filter(item => item.id === val)
      this.communityForm.phone = _item[0].username
    },
    //  获取小区经理
    async xiangMuByXiangMuJingLi() {
      let _list = await xiangMuByXiangMuJingLi()
      this.xiangmuId = _list.data.id
      this.xiangmuName = _list.data.name
    }
  },
  watch: {
    setItem() {
      this.communityForm = {
        name: this.setItem.name,
        region: this.setItem.sheng_id?[this.setItem.sheng_id.toString(), this.setItem.shi_id.toString(), this.setItem.xian_id.toString()]:[],
        region_text: this.setItem.sheng_name?[this.setItem.sheng_name, this.setItem.shi_name, this.setItem.xian_name]:[],
        address: this.setItem.address,
        beizhu: this.setItem.beizhu
      };
    }
  }
}
</script>

<style scoped lang="scss">

</style>
